<template>
  <div
    style="width: 100%"
    class="mx-0 my-2"
  >
    <v-divider class="mb-4" />
    <v-row
      class="mb-3"
      style="height: 28px"
    >
<!--      <v-subheader>-->
<!--        {{ $t('customFields') }}-->
<!--      </v-subheader>-->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            small
            color="primary"
            class="mt-2"
            v-on="on"
            text
            @click="addRow"
          >
            {{$t('addCustomeField')}}
<!--            <v-icon-->
<!--              color="teal"-->
<!--              style="font-size: 22px"-->
<!--            >-->
<!--              mdi-plus-box-outline-->
<!--            </v-icon>-->
          </v-btn>
        </template>
        <span>{{ $t('clickForAddCustomeField') }}</span>
      </v-tooltip>
    </v-row>
    <v-row
      v-for="(item, i) in items"
      :key="i"
    >
      <v-col
        cols="12"
        md="4"
        class="mb-0"
      >
        <v-combobox
          v-model="item.key"
          :items="keyItems"
          :search-input.sync="search"
          hide-selected
          :rules="[v => !!v || $t('is-required')]"
          :label="$t('additionalFields')"
          outlined
          value="key"
          dense
          :multiple="(multiple ? multiple : false)"
          small-chips
        >
          <template v-slot:no-data>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t('toCreate') }} : "<strong>{{ search }}</strong>". {{ $t('doEnter') }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <template v-slot:item="{ index, item }">
            {{ item }}
            <v-spacer />
            <v-list-item-action
              class="d-inline"
              @click.stop
            >
              <v-btn
                icon
                small
                @click.stop.prevent="edit(index, item)"
              >
                <v-icon color="grey">
                  mdi-pencil
                </v-icon>
              </v-btn>
            </v-list-item-action>
          </template>
        </v-combobox>
      </v-col>
      <v-col
        cols="12"
        md="4"
        class="mb-0"
      >
        <v-text-field
          v-model="item.value"
          :label="$t('value')"
          height="20"
          dense
          :rules="[v => !!v || $t('is-required')]"
          outlined
          class="mb-1 dense"
          clearable
        />
      </v-col>
      <v-col
        cols="12"
        sm="4"
        md="4"
        class=""
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="pink"
              icon
              small
              v-bind="attrs"
              class="ms-2 pt-1"
              v-on="on"
              @click="removeRow(item)"
            >
              <v-icon
                color="pink"
                style="font-size: 26px"
              >
                mdi-close
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('remove') }}</span>
        </v-tooltip>
      </v-col>
      <v-dialog
        :fullscreen="isMobile"
        :hide-overlay="isMobile"
        v-model="dialog"
        width="300"
      >
        <v-card
          v-if="editing"
          class="pl-4"
        >
          <v-col
            class="mt-3 pr-7"
          >
            <v-text-field
              v-model="editingText"
              filled
              dense
              autofocus
              flat
              :loading="loading"
              :disabled="loading"
            />
          </v-col>
          <v-card-actions>
            <v-btn
              color="primary"
              text
              @click="updateItem"
              :loading="loading"
            >
              {{ $t('edit') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
  export default {
    data: () => ({
      keyItems: [],
      items: [],
      loading: false,
      dialog: false,
      model: null,
      selected: null,
      lastPage: 1,
      search: null,
      type: null,
      editing: null,
      editingText: null,
      removeText: null,
      oldText: null,
      editingColor: null,
      page: 1,
    }),
    props: ['value', 'typeProp', 'multiple'],
    watch: {
      value (val) {
        this.items = val
      },
      items: {
        handler () {
          this.$emit('input', this.items)
        },
        deep: true,
      },
      search (val) {
        this.getItems()
      },
    },
    mounted () {
      if (this.value) {
        this.items = this.value
      }
      this.type = this.$route.params.type
      this.getItems()
    },
    methods: {
      addRow () {
        var row = {
          key: null,
          value: null,
        }
        this.items.push(row)
      },
      edit (index, item) {
        this.editing = item
        this.editingText = item
        this.oldText = item
        this.dialog = true
      },
      getItems () {
        var app = this
        app.loading = true
        clearTimeout(app.timer)
        app.timer = setTimeout(function () {
          app.$axios.get(app.$endpoint + 'getdetail', {
            params: {
              select: app.typeProp,
              search: app.search,
            },
          })
            .then(res => {
              res = res.data
              app.keyItems = res
            })
            .catch(err => {
              app.serverErrorHandeler(err)
            })
            .finally(function () {
              app.loading = false
            })
        }, 1000)
      },
      updateItem () {
        var app = this
        app.loading = true
        clearTimeout(app.timer)
        app.timer = setTimeout(function () {
          app.$axios.get(app.$endpoint + 'getdetail', {
            params: {
              select: 'editCustomFields',
              type: app.typeProp,
              oldKey: app.oldText,
              key: app.editingText,
            },
          })
            .then(res => {
              app.getItems()
            })
            .catch(err => {
              app.serverErrorHandeler(err)
            })
            .finally(function () {
              app.loading = false
              app.dialog = false
              app.editingText = null
              app.oldText = null
            })
        }, 1000)
      },
      removeRow (item) {
        var i = this.items.indexOf(item)
        this.items.splice(i, 1)
      },
      visibilityChanged (e) {
        // this.page++
        // e && this.getItems()
      },
      keydown: function (event) {
      },
      submit () {
      },
      filter (item, queryText, itemText) {
        if (item.header) return false

        const hasValue = val => val != null ? val : ''

        const text = hasValue(itemText)
        const query = hasValue(queryText)

        return text.toString()
          .toLowerCase()
          .indexOf(query.toString().toLowerCase()) > -1
      },
    },
  }
</script>
